export enum PublicAvailableProductType {
  Product = 'PRODUCT',
  Box = 'BOX',
}
